import { render, staticRenderFns } from "./ListRequests.vue?vue&type=template&id=4bcc7820&"
import script from "./ListRequests.ts?vue&type=script&lang=ts&"
export * from "./ListRequests.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports